export default __webpack_public_path__ + "static/media/mk.52fd939d.jpg";